/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section2_Li1Inputs */

const en_privacy_section2_li1 = /** @type {(inputs: Privacy_Section2_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON data you paste, upload, or process in any tool`)
};

const ko_privacy_section2_li1 = /** @type {(inputs: Privacy_Section2_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`도구에서 붙여넣기, 업로드 또는 처리하는 JSON 데이터`)
};

const ja_privacy_section2_li1 = /** @type {(inputs: Privacy_Section2_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ツールで貼り付け、アップロード、処理するJSONデータ`)
};

/**
* | output |
* | --- |
* | "JSON data you paste, upload, or process in any tool" |
*
* @param {Privacy_Section2_Li1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const privacy_section2_li1 = /** @type {((inputs?: Privacy_Section2_Li1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section2_Li1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_section2_li1(inputs)
	if (locale === "ko") return ko_privacy_section2_li1(inputs)
	return ja_privacy_section2_li1(inputs)
});